module.exports = __webpack_public_path__ + "img/pattern-left.2779c523.svg";